'use client';

import { Button } from '@ahafood/ui/components/button';
import { Disconnect } from '@ahamove/icons/empty';
import * as Sentry from '@sentry/nextjs';
import type Error from 'next/error';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { ResultBlock } from '@/components/result-block';
import { ROUTES } from '@/config/router';
import { Link } from '@/i18n/routing';
import { MainLayout } from '@/layouts/main';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const tSystem = useTranslations('system');

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <MainLayout>
      <ResultBlock
        icon={Disconnect}
        title={tSystem('error.title')}
        description={tSystem('error.errorHint1')}
      >
        {error.digest ? (
          <p className="text-xs font-semibold text-neutral-70 dark:text-neutral-30">
            {tSystem('error.errorDigest')}: <code>{error.digest}</code>
          </p>
        ) : null}

        <div className="!mt-6 flex flex-row flex-wrap items-center justify-center gap-4">
          <Button
            variant="outline"
            size="sm"
            className="min-w-48 bg-muted"
            onClick={() => reset()}
          >
            {tSystem('error.refreshThePage')}
          </Button>
          <Link href={ROUTES.home} passHref>
            <Button variant="outline" size="sm" className="min-w-48">
              {tSystem('links.backToHomepage')}
            </Button>
          </Link>
        </div>
      </ResultBlock>
    </MainLayout>
  );
}
